addEventListener('DOMContentLoaded', function() {
	const slidesCount = getMaxSlidesCount();
    var toursSwiper = new Swiper(".tours-swiper", {
      spaceBetween: 0,
      freeMode: false,
      watchSlidesProgress: true,
			loop: true,
			navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
			pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
			autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 1,
        },
        // when window width is >= 480px
        480: {
        slidesPerView: slidesCount > 2 ? 2 : slidesCount,
        },
        // when window width is >= 640px
        640: {
        slidesPerView: slidesCount >= 3 ? 3 : slidesCount,
        },
        // when window width is >= 1200px
        1050: {
        slidesPerView: slidesCount >= 4 ? 4 : slidesCount,
        },
        1200: {
        slidesPerView: slidesCount >= 5 ? 5 : slidesCount,
        },
        1600: {
        slidesPerView: slidesCount >= 6 ? 6 : slidesCount,
        }
    }
    });
		function getMaxSlidesCount () {
			const slidesCount = document.querySelectorAll('.wp-block-dunesblocks-tours-carousel .swiper-slide').length;
			return slidesCount;
		}
});
